export default __webpack_public_path__ + "static/media/brainstar-02.d0ba170c.png";